import {
	EnhancedCheckboxRHFWithLabel,
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";

import { Box } from "@mui/material";

interface IPaydayAdvanceInfoSetupFieldsPanel {
	employeeDDL: any;
	onEmployeeSelectionChangeHandler: (e:any) => void;
}
export const PaydayAdvanceInfoSetupFieldsPanel: FC<
	IPaydayAdvanceInfoSetupFieldsPanel
> = ({ employeeDDL,onEmployeeSelectionChangeHandler }) => {
	const [showchequeFields, setShowchequeFields] = useState(true);
	const onPaidBySelectionChangeHandler = (item: any) => {
		setShowchequeFields(item.value === 200 ? true : false);
	};
	return (
		<Box
			sx={{
				padding: "0",
			}}
		>
			<EnhancedDropDownRHFWithLabel
				selectName={"employeeId"}
				label={"Employee"}
				labelPosition={LabelPosition.Top}
				// required
				testId={`employee-ddl`}
				items={employeeDDL ?? []}
				onSelectionChangeHandler={onEmployeeSelectionChangeHandler}
			/>
			<RHookFormDatePicker
				name="dateNo"
				testId="dateNo"
				label="Date"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<RHookFormNumberFieldWithLabel
				label="Amount"
				id="amount"
				testId={`amount`}
				labelPosition={LabelPosition.Top}
				readOnly={!showchequeFields}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName={"paidBy"}
				label={"Paid By"}
				labelPosition={LabelPosition.Top}
				// required
				testId={`paid-by`}
				items={[
					{ label: "Cash", value: 100 },
					{ label: "Cheque", value: 200 },
					{ label: "Direct Deposit", value: 300 },
				]}
				onSelectionChangeHandler={onPaidBySelectionChangeHandler}
			/>

			<RHookFormTextFieldWithLabel
				label="Cheque No"
				id="chequeNo"
				testId={`chequeNo`}
				labelPosition={LabelPosition.Top}
				readOnly={!showchequeFields}
			/>
			<RHookFormDatePicker
				name="chequeDate"
				testId="chequeDate"
				label="Cheque Date"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				disabled={!showchequeFields}
			/>

			<EnhancedTextAreaFieldRHF
				label="Notes"
				id="notes"
				testId={`notes`}
				placeholder="Notes"
				labelPosition={LabelPosition.Top}
				// labelColumns={4}
				// fieldColumns={7}
			/>
			<EnhancedCheckboxRHFWithLabel
				name="printOnCheque"
				checked={false}
				testId="printOnCheque"
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
				label={"Print on Cheque"}
			/>
		</Box>
	);
};
